module.exports = __webpack_public_path__ + "img/guess-number-details4.3f028a77.png";